import { useQuery } from "@tanstack/react-query";
import { getTenants } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const getTenantsQueryKey = (offset: number, limit: number) => [
	"TENANTS_QUERY",
	offset,
	limit,
];

export function useTenantsQuery(enabled = true) {
	return useQuery({
		queryKey: [getTenantsQueryKey(0, 100)],
		queryFn: processResponse(() => getTenants(0, 100)),
		enabled,
	});
}
